import { TDataLanding } from "../../../components/Lending/types";
import { config } from "../../../config/config";
import { TBanquetForm } from "../types";
import { convertArrayToFiles } from "./createFileFromurl";

export const prepareInitialBanquetFormValues = async (
  landingData: TDataLanding
): Promise<Partial<TBanquetForm>> => {
  const gallery = await convertArrayToFiles(landingData.banketGallery || []);

  const [mainImage1, mainImage2, mainImage3] = await convertArrayToFiles(
    landingData.banketMainImages?.slice(0, 3) || []
  );

  return {
    gallery,
    phone: landingData.banketContactPhone,
    isActive: landingData.banketEnabled,
    descriptionEn:
      landingData.banketDescription?.find((el) => el.lang === "en")?.value ||
      "",
    descriptionUk:
      landingData.banketDescription?.find((el) => el.lang === "uk")?.value ||
      "",
    banketMenu: landingData.banketMenu
      ? `${config.serverURL}public/${landingData.banketMenu}`
      : undefined,
    banketTerms: landingData.banketTerms
      ? `${config.serverURL}public/${landingData.banketTerms}`
      : undefined,
    mainImage1,
    mainImage2,
    mainImage3,
  };
};

export const createBanquetFormData = async (
  data: TBanquetForm
): Promise<FormData> => {
  const formData = new FormData();

  data.gallery.forEach((file) => {
    formData.append(`banketGallery`, file);
  });

  [data.mainImage1, data.mainImage2, data.mainImage3].forEach((img, i) => {
    if (img) {
      formData.append(`banketMainImages`, img);
    }
  });

  if (data.banketMenu && typeof data.banketMenu !== "string") {
    formData.append("banketMenu", data.banketMenu);
  }

  if (data.banketTerms && typeof data.banketTerms !== "string") {
    formData.append("banketTerms", data.banketTerms);
  }

  formData.append("banketContactPhone", data.phone);
  formData.append("banketEnabled", JSON.stringify(data.isActive));

  const description = [
    { lang: "uk", value: data.descriptionUk },
    { lang: "en", value: data.descriptionEn },
  ];

  formData.append("banketDescription", JSON.stringify(description));

  return formData;
};
